/* eslint-disable */
//项目模块接口设置

import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams
} from '@/api/request' // 导入request中创建的axios实例
const project = { //项目 
  incomeAndExpenses: params => { //app项目管理-收支统计-收支情况接口-陈国贵
    return getRequest('app/project/info/incomeAndExpenses', params)
  },
  incomeAndExpensesChart: params => { //app项目管理-收支数据-陈国贵
    return getRequest('app/project/info/incomeAndExpensesChart', params)
  },
  projectExpensesDetail: (pageNum, pageSize, params) => { //app端项目支出明细接口-陈国贵
    return getRequest('app/project/info/projectExpensesDetail/' + pageNum + "/" + pageSize, params)
  },
  projectInComeDetail: (pageNum, pageSize, params) => { //app端项目收入明细接口-陈国贵
    return getRequest('app/project/info/projectInComeDetail/' + pageNum + "/" + pageSize, params)
  },
  projectMoneyDetail: (type, pageNum, pageSize, params) => { //app端项目收入或支出明细接口-陈国贵
    return type == "expend" ?
      getRequest('app/project/info/projectExpensesDetail/' + pageNum + "/" + pageSize, params)
      :
      getRequest('app/project/info/projectInComeDetail/' + pageNum + "/" + pageSize, params)
  },
  reimburseProjectExpensesDetail: (type, pageNum, pageSize, params) => { //app端项目收入或支出明细接口-陈国贵
    return type == "expend" ?
      getRequest('app/project/info/reimburseProjectExpensesDetail/' + pageNum + "/" + pageSize, params)
      :
      getRequest('app/project/info/projectInComeDetail/' + pageNum + "/" + pageSize, params)
  },
  projectBorrowAndMargin: params => { //app端（借款、保证金）金额相关统计-陈国贵
    return getRequest('app/project/info/projectBorrowAndMargin', params)
  },
  projectBorrowAndMarginDEtail: (type, params) => {
    return type == "zc" ?
      getRequest('app/project/info/getProjectExpendDetail', params) //app端（借款、保证金)支出明细接口-陈国贵
      :
      getRequest('app/project/info/toAccountDetail', params) //app端（借款、保证金)到账明细接口-陈国贵
  },

  //项目成果
  projectAchieve: {
    getDetail: id => { //项目成果出库详情-陈国贵
      return getRequest('app/projectAchieve/get/' + id, {})
    },
    projectContract: (pageNum, pageSize) => { //app-根据项目id获取项目合同信息-陈国贵
      return getRequest('app/projectAchieve/new/projectContract/' + pageNum + '/' + pageSize, {})
    },
    getWorkloadUids: params => { //app-工作量分配人员信息-陈国贵
      return getRequest('app/projectAchieve/workloadUids', params)
    },
    //项目出库申请添加接口-陈国贵|申请编辑接口-陈国贵
    addEdit: (mode, params) => {
      if (mode == "add") {
        return postRequest("app/projectAchieve/add", params); //添加接口-陈国贵
      } else {
        return postRequest("app/projectAchieve/edit", params); //申请编辑接口-陈国贵
      }
    },
    deleteRecall: (mode, id) => {
      //申请删除接口-陈国贵|申请撤回接口-陈国贵
      return mode == "hold" ?
        getRequest("app/projectAchieve/delete/" + id, {}) //申请删除接口-陈国贵
        :
        getRequest("app/projectAchieve/recall/" + id, {}); //申请撤回接口-陈国贵
    },
    //重新提交申请
    resubmission: (id) => {
      return postRequest("app/projectAchieve/againSubmit/" + id, {});
    },

  },
  //新建项目申请
  openShengList: (params) => { //查询已开通的省份区域接口-谢明
    return getRequest('base/region/openShengList', params)
  },
  linkageList: (params) => { //区域联动列表-肖东
    return getRequest('base/region/linkageList', params)
  },
  itemList: (params) => { //字典项列表接口-肖东
    return getRequest('base/dictionary/itemSelectList', params)
  },
  //项目登记申请详情
  detailProjectApply: (params) => { //项目详情查询-王愿
    return getRequest("app/project/register/projectDetail", params);
  },
  //添加项目登记申请
  addProjectApply: (mode, params) => {
    return mode == "add" ?
      postRequest("app/project/register/save", params) : //提交接口-王愿
      postRequest("app/project/register/update", params); //更新接口-王愿
  },
  //删除，撤回项目登记申请
  backProjectApply: (mode, id) => {
    return mode == "hold" ?
      postRequest("app/project/register/delete/" + id, {}) //删除接口-王愿
      :
      postRequest("app/project/register/recall/" + id, {}); //撤销接口-王愿
  },
  //获取项目成本比例
  getConfig: (params) => { //根据项目类型、金额获取项目成本比例设置--陈国贵
    return getRequest("project/cost/percent/getConfig", params);
  },
  //查看当前审核人-陈国贵
  getAuditUser: (params) => {
    return postRequestParams("app/project/register/getAuditUser", params);
  },
  //判断当前是否能撤回操作-陈国贵
  checkRecall: (id) => {
    return postRequest("app/project/register/checkRecall/" + id, {});
  },
  //项目登记申请审核操作-陈国贵
  audit: (params) => {
    return postRequest("app/project/register/audit", params);
  },
  //项目进度列表接口-王愿*/
  configList: (pageNum, pageSize, params) => {
    return getRequest("project/normal/progress/setting/list/" + pageNum + '/' + pageSize, params)
  },
  //项目类型占比统计-陈国贵
  projectTypeRatio: (params) => {
    return getRequest("app/project/info/projectTypeRatio", params)
  },
   //项目区域排行榜统计-陈国贵
   projectRegionRank: (params) => {
    return getRequest("app/project/info/projectRegionRank", params)
  },
}

export default project